import React from 'react';

type SelectButtonProps = { buttonNumber: number };

const ButtonList: React.FC<SelectButtonProps> = (props) => {
  return (
    <div>
      <button>No. {props.buttonNumber}</button>
    </div>
  );
};

export const App: React.FC = () => {
  const ary: number[] = [1, 2, 3, 4, 5];

  return (
    <>
      {ary.map((d) => (
        <ButtonList buttonNumber={d} key={d} />
      ))}
      <h1>Hello World</h1>
    </>
  );
};
